if (!customElements.get('arn-skeleton-loader')) {
  class ArnSkeletonLoader extends HTMLElement {
    constructor() {
      super();
      this.childElement = this.dataset.childElement;
    }

    connectedCallback() {
      const banner = this.parentElement?.querySelector('.arn-skeleton-loader-banner');
      if (banner) banner.style.display = 'none';
      this.style.display = 'block';
    }
  }

  customElements.define('arn-skeleton-loader', ArnSkeletonLoader);
}
